import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import get from 'lodash.get';

import StorefrontAboutSection from './StorefrontAboutSection';
import StorefrontMediaSection from './StorefrontMediaSection';
import StorefrontArticleSection from './StorefrontArticleSection';
import StorefrontFeaturedSection from './StorefrontFeaturedSection';

function StorefrontHome({ ...props }) {
    return (
        <React.Fragment>
            {/* About {Seller} */}
            <StorefrontAboutSection seller={props.seller} sellerData={props.sellerData} />

            {/* Featured Pieces */}
            {get(props, 'products.edges.length') ? (
                <StorefrontFeaturedSection
                    isPreview={props.isPreview}
                    seller={props.seller}
                    isTrade={props.isTrade}
                    user={props.user}
                    viewer={props.viewer}
                    products={props.products}
                />
            ) : null}

            {/* Media Section */}
            <StorefrontMediaSection seller={props.seller} />

            {/* Articles Section */}
            <StorefrontArticleSection seller={props.seller} isPreview={props.isPreview} />
        </React.Fragment>
    );
}

StorefrontHome.propTypes = {
    isTrade: PropTypes.bool,
    isPreview: PropTypes.bool.isRequired,
    sellerData: PropTypes.shape({
        dealerSince: PropTypes.string.isRequired,
    }).isRequired,

    // fetched data
    user: PropTypes.object,
    viewer: PropTypes.object.isRequired,
    seller: PropTypes.object.isRequired,
    products: PropTypes.object,
};

export default createFragmentContainer(StorefrontHome, {
    viewer: graphql`
        fragment StorefrontHome_viewer on Viewer {
            ...StorefrontFeaturedSection_viewer
        }
    `,
    user: graphql`
        fragment StorefrontHome_user on User {
            ...StorefrontFeaturedSection_user
        }
    `,
    seller: graphql`
        fragment StorefrontHome_seller on Seller {
            ...StorefrontAboutSection_seller
            ...StorefrontMediaSection_seller
            ...StorefrontArticleSection_seller
            ...StorefrontFeaturedSection_seller
        }
    `,
    products: graphql`
        fragment StorefrontHome_products on DealerStorefrontQueryConnection {
            edges {
                node {
                    serviceId
                }
            }
            ...StorefrontFeaturedSection_products
        }
    `,
});
